import { ImpactHeaderJadlog } from "@/components/impactoJadlog/ImpactHeaderJadlog";
import { ImpactInfoBannerJadlog } from "@/components/impactoJadlog/ImpactInfoBannerJadlog";
import { ImpactFiltersJadlog } from "@/components/impactoJadlog/ImpactFiltersJadlog";
import { MaterialSummaryCardJadlog } from "@/components/impactoJadlog/MaterialSummaryCardJadlog";
import { ImpactKPICardsJadlog } from "@/components/impactoJadlog/ImpactKPICardsJadlog";
import { ImpactEvolutionChartJadlog } from "@/components/impactoJadlog/ImpactEvolutionChartJadlog";
import { ImpactByMaterialChartJadlog } from "@/components/impactoJadlog/ImpactByMaterialChartJadlog";
import { ImpactByUnitChartJadlog } from "@/components/impactoJadlog/ImpactByUnitChartJadlog";
import { useImpactDataJadlog } from "@/hooks/useImpactDataJadlog";
import { Skeleton } from "@/components/ui/skeleton";

const DadosDeImpactoJadlog = () => {
  const {
    filters,
    updateFilters,
    resetFilters,
    dateShortcuts,
    data,
    isLoading,
    establishmentOptions,
    wasteTypeOptions,
    closedMonths,
    semRegraMaterials,
  } = useImpactDataJadlog();

  if (isLoading) {
    return (
        <div className="p-6 space-y-6">
          <Skeleton className="h-12 w-64" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-40 w-full" />
          <div className="grid grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="h-28" />
            ))}
          </div>
        </div>
    );
  }

  return (
      <div className="min-h-screen bg-background p-4 md:p-6 w-full overflow-x-hidden">
        <div className="max-w-7xl mx-auto space-y-4 md:space-y-6 min-w-0">
          {/* Header */}
          <ImpactHeaderJadlog filters={filters} data={data} />

          {/* Simplified Filters */}
          <ImpactFiltersJadlog
            filters={filters}
            onFiltersChange={updateFilters}
            onClearFilters={resetFilters}
            dateShortcuts={dateShortcuts}
            closedMonths={closedMonths}
            establishmentOptions={establishmentOptions}
            wasteTypeOptions={wasteTypeOptions}
          />

          {/* Info Banner - Collapsible */}
          <ImpactInfoBannerJadlog />

          {/* Material Summary */}
          <MaterialSummaryCardJadlog
            totalWeight={data.totalWeight}
            materials={data.materialSummary}
            semRegraMaterials={semRegraMaterials}
          />

          {/* KPI Cards - 3 on top, 2 on bottom */}
          <ImpactKPICardsJadlog kpis={data.kpis} />

          {/* Charts Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ImpactEvolutionChartJadlog data={data.evolutionData} />
            <ImpactByMaterialChartJadlog data={data.impactByMaterial} />
          </div>

          {/* Unit Ranking */}
          <ImpactByUnitChartJadlog data={data.unitRanking} />

          {/* Disclaimer */}
          <div className="text-xs text-muted-foreground leading-relaxed bg-muted/30 rounded-lg p-4 border border-border/50">
            <p>
              Os dados de impacto ambiental apresentados são estimativas
              calculadas a partir de modelos teóricos, fatores médios de
              conversão e premissas técnicas, estando sujeitos a variações
              decorrentes de metodologias de amostragem, taxas médias de
              eficiência, contaminação e arredondamentos. Os resultados têm
              caráter informativo e analítico, servindo exclusivamente para
              acompanhamento e análise de tendências, não devendo ser
              interpretados como medições exatas, valores certificados ou
              garantias de resultados ambientais.
            </p>
          </div>
        </div>
      </div>
  );
};

export default DadosDeImpactoJadlog;
